import styles from './SpecificationFields.module.css';

/**
 * One scale from the case specification, as a radio group.
 *
 * Real radios rather than styled buttons: a screen reader announces "2 of 3"
 * and the arrow keys move through the row, which is what somebody who cannot
 * see which option is filled in needs.
 *
 * The options are spelled out and every scale ascends. The paper form used
 * single letters and ran them in different directions on different rows, which
 * is how the client came to ask what one of them meant. A word cannot be
 * misread and one direction cannot be misordered.
 */
export function ScaleChoice<Value extends string>({
  name,
  label,
  options,
  labels,
  value,
  onChange,
}: {
  name: string;
  label: string;
  options: readonly Value[];
  labels: Record<Value, string>;
  value: Value;
  onChange: (next: Value) => void;
}) {
  return (
    <fieldset className={styles.group}>
      <legend className={styles.l}>{label}</legend>
      <div className={styles.scale}>
        {options.map((option) => (
          <label key={option} className={`${styles.step} ${option === value ? styles.on : ''}`}>
            <input
              type="radio"
              name={name}
              value={option}
              checked={option === value}
              onChange={() => onChange(option)}
            />
            {labels[option]}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
